import { useMutation } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function useUpdateEverifyUser() {
  return useMutation({
    mutationFn: async ({ companyId, body }) => {
      const { data } = await api.put("/user/updateuser", body, {
        headers: { "x-company-id": String(companyId) },
      });
      return data;
    },
  });
}
